import { render } from "./Kaidiantwo.vue?vue&type=template&id=2487bc12&scoped=true"
import script from "./Kaidiantwo.vue?vue&type=script&lang=js"
export * from "./Kaidiantwo.vue?vue&type=script&lang=js"

import "./Kaidiantwo.vue?vue&type=style&index=0&id=2487bc12&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2487bc12"]])

export default __exports__